export default {
      id: "271,8_cm_=_120_+_60_+_28,4_+_60-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#271,8_cm_=_120_+_60_+_28,4_+_60",
      toString: function () {
        return this.url;
      }
    }